module.exports = __webpack_public_path__ + "static/img/anxun84.804499b3.png";